import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, RouterModule, Routes } from '@angular/router';
import { HighlightPageResolver } from '@modules/content-api/resolver/highlight.resolver';
import { MagazineResolver } from '@modules/content-api/resolver/magazine.resolver';
import { TestCarPageResolver } from '@modules/content-api/resolver/test-car-page.resolver';
import { TestRouteResolver } from '@modules/content-api/resolver/test-route.resolver';
import { TopicAndMagazineBreadcrumbResolver, TopicResolver } from '@modules/content-api/resolver/topic.resolver';
import { LightboxPageComponent } from '@modules/shared/lightbox/lightbox-page.component';

import { MagazinePageComponent } from './magazine-page.component';
import { PageViewComponent } from './page-view.component';

const routes: Routes = [
  {
    path: '',
    component: PageViewComponent,
    resolve: {
      breadcrumb: TopicAndMagazineBreadcrumbResolver,
    },
    children: [
      {
        path: '',
        component: MagazinePageComponent,
        data: {
          keepBreadcrumbs: true,
        },
        resolve: {
          // set breadcrumb to undefined and only use the parents breadcrumb
          breadcrumb: (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => undefined,
          topic: TopicResolver,
          magazine: MagazineResolver,
        },
        children: [
          {
            path: ':resourceType/:resourceId',
            component: LightboxPageComponent,
            outlet: 'lightbox',
          },
        ],
      },
      {
        path: 'test-routes/:id',
        resolve: {
          testRoutePageData: TestRouteResolver,
        },
        loadChildren: () => import('./../test-route-page/test-route-page.module').then((m) => m.TestRoutePageModule),
      },
      {
        path: 'test-cars/:testCarSectionId',
        resolve: {
          testCarPage: TestCarPageResolver,
        },
        loadChildren: () => import('../test-car-page/test-car-page.module').then((m) => m.TestCarPageModule),
      },
      {
        path: 'highlight/:highlightId',
        resolve: {
          highlight: HighlightPageResolver,
        },
        loadChildren: () => import('./../highlight-page/highlight-page.module').then((m) => m.HighlightPageModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MagazineRoutingModule {}
